import React from 'react';
import PropTypes from 'prop-types';

import S from 'app/features/landing/productComparison/components/Product/Benefits.styled';
import connect from 'app/libs/connect';
import Benefit from 'app/features/landing/productComparison/components/Product/Benefit';
import {
  productBenefits,
  prevProductTitleKey,
} from 'app/features/products/selectors';

const UI = ({ prevProductTitleKey, benefits }) => (
  <S.Benefits>
    {prevProductTitleKey && (
      <Benefit
        key={`${prevProductTitleKey}`}
        titleId="landing_plans_perk_get_all_from_previous"
        values={{ prevProductTitleKey }}
        isVisibleOnDesktop={false}
        isVisibleOnMobile
        isReferenceBenefit
        isActive
      />
    )}
    {benefits.map(benefit => (
      <Benefit
        key={`${benefit.titleId}`}
        titleId={benefit.titleId}
        isActive={benefit.isActive}
        isVisibleOnDesktop={benefit.isVisibleOnDesktop}
        isVisibleOnMobile={benefit.isVisibleOnMobile}
        values={benefit.values}
      />
    ))}
  </S.Benefits>
);

UI.propTypes = {
  prevProductTitleKey: PropTypes.string,
  benefits: PropTypes.arrayOf(
    PropTypes.shape({
      titleId: PropTypes.string.isRequired,
      isActive: PropTypes.bool.isRequired,
      isVisibleOnMobile: PropTypes.bool,
      isVisibleOnDesktop: PropTypes.bool,
      values: PropTypes.shape({
        placeholder: PropTypes.string,
        prevProductTitleKey: PropTypes.string,
      }),
    }),
  ),
};

UI.defaultProps = {
  prevProductTitleKey: null,
  benefits: [],
};

UI.displayName = 'Benefits';

const state = { benefits: productBenefits, prevProductTitleKey };

const Benefits = connect(state)(UI);

export { UI };

export default Benefits;
